import { render } from "./VehicleKpis.vue?vue&type=template&id=3d9b4432&scoped=true"
import script from "./VehicleKpis.vue?vue&type=script&lang=js"
export * from "./VehicleKpis.vue?vue&type=script&lang=js"

import "./VehicleKpis.vue?vue&type=style&index=0&id=3d9b4432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9b4432"]])

export default __exports__